// Dependencias generales
import React from "react";
import { useEffect } from 'react';
import AppLogoImg from '../../components/Utils/AppLogoImg';

import logoEfergy from '../../img/brands/efergy.svg'
import logoEwelink from '../../img/brands/ewelink.svg'
import logoFusionSolar from '../../img/brands/fusion-solar.svg' 
import logoSmartlife from '../../img/brands/smart-life.svg'
import logoTuya from '../../img/brands/tuya.svg'
import logoTesla from '../../img/brands/tesla.svg'
import logoTplink from '../../img/brands/tplink.svg'
import logoVictron from '../../img/brands/victron.svg'
import logoHelias from '../../img/brands/helias.png'
import logoShelly from '../../img/brands/shelly.svg'
import logoTapo from '../../img/brands/tapo.svg'
import logoARISTON from '../../img/brands/ariston-net.svg'
import logoBRONPI from '../../img/brands/bronpi.svg'
import logoSOLARWEB from '../../img/brands/solarweb.svg'
import logoECOFORESTCONTROL from '../../img/brands/ecoforest-control.svg'
import logoBROADLINK from '../../img/brands/broadlink.svg'
import logoHOME_ASSISTANT from '../../img/brands/homeassistant.svg'
import logoKOSTAL from '../../img/brands/kostal.svg'
import logoIberdrolaSmartMonitor from '../../img/brands/IberdrolaSmartMonitor.svg'
import logoEnergeeks30 from '../../img/brands/energeeks30.svg'
import logoSolarman from '../../img/brands/solarmansmart.svg'
import logoEDPSolar from '../../img/brands/edp-solar.svg'
import logoESAJHome from '../../img/brands/esaj-home.svg'
import logoiAquaLink from '../../img/brands/iaqualink.svg'
import logoMELCloud from '../../img/brands/MELCloud.svg'
import logoComfortCloud from '../../img/brands/panasonic-comfort-cloud-app.svg'
import logoMeross from '../../img/brands/meross.svg'
import logoOnecta from '../../img/brands/daikin-onecta.svg'
import logoGovee from '../../img/brands/govee-home.svg'
import logoXiaomi from '../../img/brands/xiaomi-home.svg'
import logoSmartThings from '../../img/brands/smartthings.svg'

import Loader from '../../components/Utils/Loader';

import ReactGA from "react-ga4";

var initialConfigCommonJS = require("../../js/initialConfigCommon.js");
var dashboardCommonJS = require("../../js/dashboardCommon.js");

const AvailableDevicesList = (params) => {

  useEffect(() => {        
    document.getElementById("tituloDispositivosDisponibles").innerHTML = params.AppName.replace("_", " ")

    if(params.AppName === "SHELLY"){
      
      if( (document.getElementById("selectTipoSistemaElectricoInstalacion") !== null) && (document.getElementById("selectTipoSistemaElectricoInstalacion").value === "MONOFASICO") ){
        document.getElementById("mensajeAclaracionSHELLY").className = document.getElementById("mensajeAclaracionSHELLY").className.replaceAll(" hidden", "")
      }
      else{
        document.getElementById("mensajeAclaracionSHELLY").className = document.getElementById("mensajeAclaracionSHELLY").className.replaceAll(" hidden", "") + " hidden"
      }

    } 

    var camposSensores = initialConfigCommonJS.obtenerCamposSensores()
    var mostrarInstruccionesMonitorTuyaSmartlife = false

    for(var x = 0; x < params.devicesList.length; x++){      
      if(params.devicesList[x].Nombre.includes("(N/A Wh)")){
        mostrarInstruccionesMonitorTuyaSmartlife = true
      }
      break
    }

    if( ( (params.AppName === "TUYA") || (params.AppName === "SMARTLIFE") ) && (camposSensores.toString().includes(localStorage.getItem("deviceToConfigure"))) && (mostrarInstruccionesMonitorTuyaSmartlife) ){
      document.getElementById("mensajeAclaracionMONITORTUYASMARTLIFE").className = document.getElementById("mensajeAclaracionMONITORTUYASMARTLIFE").className.replaceAll(" hidden", "")
    }
    else{
      document.getElementById("mensajeAclaracionMONITORTUYASMARTLIFE").className = document.getElementById("mensajeAclaracionMONITORTUYASMARTLIFE").className.replaceAll(" hidden", "") + " hidden"
    }
    

  });

  function obtenerImagen(app){

    var imgLogo = ""
  
    if(app === "EFERGY"){imgLogo = logoEfergy}
    else if(app === "EWELINK"){imgLogo = logoEwelink}
    else if(app === "SMARTLIFE"){imgLogo = logoSmartlife}
    else if(app === "FUSIONSOLAR"){imgLogo = logoFusionSolar}    
    else if(app === "TUYA"){imgLogo = logoTuya}
    else if(app === "TESLA"){imgLogo = logoTesla}
    else if(app === "TPLINK"){imgLogo = logoTplink}
    else if(app === "VICTRON"){imgLogo = logoVictron}
    else if(app === "HELIAS"){imgLogo = logoHelias}
    else if(app === "SHELLY"){imgLogo = logoShelly}
    else if(app === "TAPO"){imgLogo = logoTapo}
    else if(app === "ARISTON"){imgLogo = logoARISTON}
    else if(app === "BRONPI"){imgLogo = logoBRONPI}
    else if(app === "SOLARWEB"){imgLogo = logoSOLARWEB}
    else if(app === "ECOFORESTCONTROL"){imgLogo = logoECOFORESTCONTROL}
    else if(app === "BROADLINK"){imgLogo = logoBROADLINK}
    else if(app === "HOME_ASSISTANT"){imgLogo = logoHOME_ASSISTANT}
    else if(app === "KOSTAL"){imgLogo = logoKOSTAL}
    else if(app === "KOSTAL_LOCAL"){imgLogo = logoKOSTAL}
    else if(app === "IBERDROLA_SMART_MONITOR"){imgLogo = logoIberdrolaSmartMonitor}
    else if(app === "EDP_SOLAR"){imgLogo = logoEDPSolar}
    else if(app === "ENERGEEKS_30"){imgLogo = logoEnergeeks30}
    else if(app === "SOLARMAN"){imgLogo = logoSolarman}
    else if(app === "ESAJ_HOME"){imgLogo = logoESAJHome}
    else if(app === "IAQUALINK"){imgLogo = logoiAquaLink}
    else if(app === "MELCLOUD"){imgLogo = logoMELCloud}    
    else if(app === "COMFORT_CLOUD"){imgLogo = logoComfortCloud}   
    else if(app === "MEROSS"){imgLogo = logoMeross}   
    else if(app === "ONECTA_DAIKIN"){imgLogo = logoOnecta}
    else if(app === "GOVEE"){imgLogo = logoGovee}
    else if(app === "XIAOMI"){imgLogo = logoXiaomi}
    else if(app === "SMARTTHINGS"){imgLogo = logoSmartThings}

    return imgLogo   
  
  }

  function seleccionarDispositivo(marcaDispositivo, idDispositivo, nombreDispositivo){
    
    var campoDispositivoActual = localStorage.getItem("deviceToConfigure")
    
    if(campoDispositivoActual !== null){
      document.getElementById(campoDispositivoActual+"FieldsetSinConfigurar").style="display: none"
      document.getElementById(campoDispositivoActual+"FieldsetSeleccionado").style="display"
      
      document.getElementById(campoDispositivoActual+"LogoApp").src = obtenerImagen(marcaDispositivo)    
      document.getElementById(campoDispositivoActual+"Span").innerHTML = nombreDispositivo.split("(")[0]
      document.getElementById(campoDispositivoActual).value = marcaDispositivo+"|"+idDispositivo

      if(localStorage.getItem("ongoingStepConfiguration").includes("GENERAL_INFO")){
        if(document.getElementById("acometidaPrincipal1").value !== "" ){
          document.getElementById("fieldsetInstalacionConectada").className = document.getElementById("fieldsetInstalacionConectada").className.replaceAll(" hidden", "")
        }
        else{
          document.getElementById("fieldsetInstalacionConectada").className = document.getElementById("fieldsetInstalacionConectada").className + " hidden"
        }
      }

      initialConfigCommonJS.operarMenuLateral("cerrar")

      if(localStorage.getItem("installationConfigurationMode") === "true"){
        initialConfigCommonJS.mostrarMensajeInformativo('Recuerda usar el botón "Guardar configuración" para que los cambios queden activos.',"info")
      }

      try{
        document.getElementById("labelCheckboxCargaEnInstalacion").className = document.getElementById("labelCheckboxCargaEnInstalacion").className.replaceAll(" hidden", "")
      }
      catch(error){console.log(error)}      

    }

  }

  function borrarAplicacion(){
    initialConfigCommonJS.borrarAplicacion(params.AppName, params, ReactGA)
  }

  function mensajeConfimacionEliminarAplicacion(){
    
    initialConfigCommonJS.mostrarMensajeConfirmacionBorrado("delete","BORRADO DE APLICACIÓN", "¿ Estás seguro de que quieres borrar la aplicación "+params.AppName.replace("_"," ")+" ?", borrarAplicacion, initialConfigCommonJS.cerrarMensajeBorrado)          
    
  }

  const DevicesListClickable = () => {   

    if(params.devicesList.length > 0){      
      const listDevices = params.devicesList.map((device) =>   
        <React.Fragment key={device.IdDispositivo}>                    
          <input type="button" id={device.IdDispositivo} onClick={() => seleccionarDispositivo(device.MarcaDispositivo, device.IdDispositivo, device.Nombre)}/>
          <label className="icon-wrapper cyan no-radio" htmlFor={device.IdDispositivo}>
            <figure className="avatar size-m"><span className="material-icon">{dashboardCommonJS.obtenerIconoGrupoDispositivos(device.TipoDispositivo)}</span></figure>
            <span className="label">{device.Nombre}</span>
          </label>          
        </React.Fragment>      
      );    
      return (
        <>{listDevices}</>
      )
    }
    else{           
      return (
        <>
        <p>Esta aplicación no tiene dispositivos disponibles.</p>

        { params.AppName === "TUYA" || params.AppName === "SMARTLIFE" ?
          <>
          <p className="size-s"><strong>POSIBLES CAUSAS DEL PROBLEMA:</strong></p>
          <ul className="default-list">
            <li className="arrow"><strong>Es posible que tus credenciales hayan cambiado</strong>, prueba a volver a introducirlas usando el botón de "Actualizar credenciales".</li>
            <li className="arrow"><strong>Es posible que tu suscripción "trial" TUYA / SMARTLIFE haya expirado</strong>, <a href="https://fevergy.com/pdf/TRIAL_TUYA_SMARTLIFE.pdf" rel="noopener noreferrer" target="_blank" className="link inline-link">pulsa aquí</a> y sigue las instrucciones para extender tu suscripción gratuita. Si tienes que hacer esto muy a menudo intenta reducir la frecuencia de las reglas que usen esta marca de dispositivos.</li>
            <li className="arrow"><strong>Si tienes más de 50 dispositivos configurados</strong> en la aplicación no te aparecerán aquí ya que la cobertura gratuita de TUYA / SMARTLIFE es hasta 50. Una opción sería que crees 2 cuentas de TUYA / SMARTLIFE y dejes en una de ellas los dispositivos que quieras controlar desde Helias.</li>
          </ul>
          </>
        :
          <>
            <p className="size-s"><strong>POSIBLES CAUSAS DEL PROBLEMA:</strong></p>
            <ul className="default-list">
              <li className="arrow"><strong>Es posible que tus credenciales hayan cambiado</strong>, prueba a volver a introducirlas usando el botón de "Actualizar credenciales".</li>              
            </ul>
          </>
        }
        </>
      );
    }

  }
  
  const DevicesListNoClickable = () => {    

    if(params.devicesList.length > 0){      
      const listDevices = params.devicesList.map((device) =>   
        <React.Fragment key={device.IdDispositivo}>          
          <li className="horizontal gap-03 vertical-center" type="button" id={device.IdDispositivo} onClick={() => seleccionarDispositivo(device.MarcaDispositivo, device.IdDispositivo, device.Nombre)}>
            <figure className="avatar size-m"><span className="material-icon">{dashboardCommonJS.obtenerIconoGrupoDispositivos(device.TipoDispositivo)}</span></figure>
            <span className="label clarification">{device.Nombre}</span>
          </li>
          
        </React.Fragment>      
      );    
      return (
        <>{listDevices}</>
      )
    }
    else{           
      return (
        <>
        <p>Esta aplicación no tiene dispositivos disponibles.</p>

        { params.AppName === "TUYA" || params.AppName === "SMARTLIFE" ?
          <>
          <p className="size-s"><strong>POSIBLES CAUSAS DEL PROBLEMA:</strong></p>
          <ul className="default-list">
            <li className="arrow"><strong>Es posible que tus credenciales hayan cambiado</strong>, prueba a volver a introducirlas usando el botón de "Actualizar credenciales".</li>
            <li className="arrow"><strong>Es posible que tu suscripción "trial" TUYA / SMARTLIFE haya expirado</strong>, <a href="https://fevergy.com/pdf/TRIAL_TUYA_SMARTLIFE.pdf" rel="noopener noreferrer" target="_blank" className="link inline-link">pulsa aquí</a> y sigue las instrucciones para extender tu suscripción gratuita. Si tienes que hacer esto muy a menudo intenta reducir la frecuencia de las reglas que usen esta marca de dispositivos.</li>
            <li className="arrow"><strong>Si tienes más de 50 dispositivos configurados</strong> en la aplicación no te aparecerán aquí ya que la cobertura gratuita de TUYA / SMARTLIFE es hasta 50. Una opción sería que crees 2 cuentas de TUYA / SMARTLIFE y dejes en una de ellas los dispositivos que quieras controlar desde Helias.</li>
          </ul>
          </>
        :
          <>
            <p className="size-s"><strong>POSIBLES CAUSAS DEL PROBLEMA:</strong></p>
            <ul className="default-list">
              <li className="arrow"><strong>Es posible que tus credenciales hayan cambiado</strong>, prueba a volver a introducirlas usando el botón de "Actualizar credenciales".</li>              
            </ul>
          </>
        }
        </>
      );
    }


  }

  function actualizarCredencialesAplicacion(){

    localStorage.setItem("devicesAction","MODIFICATION")

    initialConfigCommonJS.navegarFlujoAplicacionesDispositivos("formularioRegistroAplicacion","noUpdate")

  }

  return (  
    <>
    <header>
      <figure className="avatar size-m orange"><AppLogoImg aplicacion={params.AppName}/></figure>
      <h1 id="tituloDispositivosDisponibles" className="headline-03">Seleccionar dispositivo</h1>
    </header>
    <section className="brands">
      <section className="brand-detail">
        <div className="brand-detail-inner">
                   
          <section className="brand-detail-content">

            { localStorage.getItem("ongoingStepConfiguration") === "DEVICES" ?

            <ul id="fieldsetDispositivos" className="vertical gap-04 cyan" aria-label="Dispositivos disponibles">
			        <DevicesListNoClickable/>                      
            </ul>
            :
            <fieldset id="fieldsetDispositivos" className="radio multiple">
              <legend>Selecciona uno de los siguientes dispositivos:</legend>
			        <DevicesListClickable/>                      
            </fieldset>
            
            }
            
            <div id="mensajeAclaracionSHELLY" className="message info left hidden">
              <h1>¿No sabes cual elegir?</h1>
              <p>Si dudas <strong>selecciona el que mayor "W" tenga</strong> ya que normalmente es el que mide toda la instalación.</p>
            </div>
            
            <div id="mensajeAclaracionMONITORTUYASMARTLIFE" className="message warning left hidden">
              <h1>Algún dispositivo necesita que lo configures</h1>
              <p>¡Vaya!, parece que alguno de tus dispositivos necesita configuración adicional. Tienes que realizarlo para cada dispositivo que tenga a la derecha del nombre "(N/A Wh)". Aquí tienes las <a href="https://www.fevergy.com/pdf/MONITOR_TUYA_SMARTLIFE.pdf" rel='noopener noreferrer' target='_blank' className='link inline-link'><strong>instrucciones</strong></a>.</p>
            </div>

            <div id="mensajeProblemaGeneralAplicacion3p" className="message warning left hidden">
              <h1>¡Vaya, hay problemas con esta aplicación!</h1>
              <p>Por algún motivo no puedo conectarme a tus dispositivos de esta marca.</p>              
              <ul className="default-list">
              <li className="arrow"><strong>¿Has cambiado la contraseña?</strong>, en tal caso utiliza el botón <strong>"Actualizar credenciales"</strong>.</li>              
                <li className="arrow">O bien, puede tratarse de un <strong>problema puntual del fabricante</strong> (Ej: Servidor caído). Revisa si puedes acceder con la aplicación de la marca. Si funciona, probablemente será error nuestro. <strong>Repórtanos el error</strong> desde el apartado de <a href="/Support" rel='noopener noreferrer' target='_self' className='link inline-link'><strong>Ayuda y soporte</strong></a>.</li>                                
              </ul>     
            </div>

            <div id="divLoaderDevices" className="loader hidden">
              <progress aria-label="Validando credenciales..."></progress>
            </div>

            <fieldset className="vertical gap-02">
              <button className="button primary full-width" onClick={() => actualizarCredencialesAplicacion()}>Actualizar credenciales</button>
              <button className="button delete primary full-width" onClick={() => mensajeConfimacionEliminarAplicacion()}>Eliminar esta aplicación</button>
            </fieldset>

          </section>      
        </div>
      </section>
    </section>

    <Loader Id="loaderDispositivosDisponibles" Mensaje=""/>

    </>
  )
}

export default AvailableDevicesList